import script from "./ProviderDesc.vue?vue&type=script&setup=true&lang=js"
export * from "./ProviderDesc.vue?vue&type=script&setup=true&lang=js"

import "./ProviderDesc.vue?vue&type=style&index=0&id=694ff484&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-694ff484"]])

export default __exports__